import {
  EntranceByEventDto,
  EventDataDto,
  EventIndexPaginatedDto,
  EventIndexQueryDto,
} from "@/pages/events/types";
import { env } from "@/config/env";
import { api } from "@/config/axiosInstance";

export const useEvent = () => {
  const getEvents = ({
    page,
    name,
    branchName,
    typeName,
    date,
    teamName,
    situation,
  }: EventIndexQueryDto) => {
    let params = `page=${page}&perPage=${env.per_page}`;

    if (name) {
      params = `${params}&name=${name}`;
    }
    if (branchName) {
      params = `${params}&branchName=${branchName}`;
    }

    if (typeName) {
      params = `${params}&typeName=${typeName}`;
    }

    if (teamName) {
      params = `${params}&teamName=${teamName}`;
    }

    if (date) {
      params = `${params}&date=${date}`;
    }

    if (situation !== undefined) {
      params = `${params}&situation=${situation}`;
    }

    return api.get<EventIndexPaginatedDto>(`/event/index?${params}`);
  };

  const getEntrancesByEventId = async (
    eventId: number
  ): Promise<EntranceByEventDto[]> => {
    try {
      const { data } = await api.get("/event/by-event", {
        params: { eventId },
      });
      return data;
    } catch (error) {
      console.error("Erro ao buscar entrances:", error);
      return [];
    }
  };

  const eventCreate = async (data: FormData) => {
    return api.post<EventDataDto>("event/create", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

  const eventUpdate = async (id: number, data: FormData) => {
    return api.put<EventDataDto>(`event/${id}`, data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  };

  const getEventById = (id: number) => {
    return api.get(`/event/${id}`);
  };

  const accountForReception = (accountId: number, eventId: number) => {
    return api.post(`/event/account-for-reception/${eventId}`, { accountId });
  };

  const removeAccountForReception = (eventId: number, accountId: number) => {
    return api.delete(`/event/account-for-reception/${eventId}/${accountId}`);
  };

  return {
    getEvents,
    eventCreate,
    eventUpdate,
    getEntrancesByEventId,
    getEventById,
    accountForReception,
    removeAccountForReception,
  };
};
